import React from "react";
import { Helmet } from "react-helmet-async";
import { canonical, OG_IMAGE } from "../../lib/seo";

/**
 * Per-page <head>: title, description, canonical, Open Graph + Twitter.
 * `route` is a ROUTES entry ({ path, title, desc }). `image` optional override.
 */
export default function Seo({ route, image = OG_IMAGE, type = "website", children }) {
  const url = canonical(route.path);
  return (
    <Helmet prioritizeSeoTags>
      <title>{route.title}</title>
      <meta name="description" content={route.desc} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content="Antara — Bhajan Jamming" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={route.title} />
      <meta property="og:description" content={route.desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={route.title} />
      <meta name="twitter:description" content={route.desc} />
      <meta name="twitter:image" content={image} />
      {children}
    </Helmet>
  );
}
